import React from "react";
import Box from "@material-ui/core/Box";
import CardActions from "@material-ui/core/CardActions";
import { Pagination } from "@material-ui/lab";

import { makeStyles } from "@material-ui/core/styles";
import componentStyles from "../assets/styles/components/issue_pagination";

const useStyles = makeStyles(componentStyles);

const IssuePagination = (props) => {
  const classes = useStyles();
  const { limit, offset, total_count } = props;
  const totalPage = Math.ceil(total_count / limit) || 0;
  const correntPage = offset / limit + 1;

  const handleClickPageNumber = (page) => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    props.handleClickPageNumberFunc(page);
  };

  return (
    <>
      <Box
        classes={{ root: classes.cardActionsRoot }}
        component={CardActions}
        justifyContent="flex-end"
      >
        <Pagination
          count={totalPage}
          color="primary"
          variant="outlined"
          page={correntPage}
          onChange={(e, page) => {
            handleClickPageNumber(page);
          }}
        />
      </Box>
    </>
  );
};

export default IssuePagination;
